import {
	CoinsHand,
	File06,
	FileShield02,
	Globe06,
	Tool01,
	Wallet02,
} from "@untitledui/icons";
import { Fuel } from "lucide-react";
import type { ComponentType } from "react";
import type { ExpenseTypeCode } from "../types";

export const REPORT_SUMMARY_CARD_ICONS: Record<
	ExpenseTypeCode,
	ComponentType<{ className?: string }>
> = {
	1: FileShield02, // Infração
	2: Tool01, // Manutenção
	3: CoinsHand, // Pedágio
	4: Wallet02, // Reembolso
	5: Fuel, // Combustível
	6: Globe06, // Viagem
	7: File06, // Outros
};

export const REPORT_SUMMARY_CATEGORY_NAMES: Record<ExpenseTypeCode, string> = {
	1: "Infração", // Infração
	2: "Manutenção", // Manutenção
	3: "Pedágio", // Pedágio
	4: "Reembolso", // Reembolso
	5: "Combustível", // Combustível
	6: "Viagem", // Viagem
	7: "Outros", // Outros
};

export const REPORT_SUMMARY_CATEGORY_TEXT_COLORS: Record<
	ExpenseTypeCode,
	string
> = {
	1: "text-[#ef4444]", // Infração
	2: "text-[#f59e0b]", // Manutenção
	3: "text-[#8b5cf6]", // Pedágio
	4: "text-[#14b8a6]", // Reembolso
	5: "text-[#10b981]", // Combustível
	6: "text-[#3b82f6]", // Viagem
	7: "text-[#9ca3af]", // Outros
};
export const REPORT_SUMMARY_CATEGORY_COLORS: Record<ExpenseTypeCode, string> = {
	1: "#ef4444", // Infração
	2: "#f59e0b", // Manutenção
	3: "#8b5cf6", // Pedágio
	4: "#14b8a6", // Reembolso
	5: "#10b981", // Combustível
	6: "#3b82f6", // Viagem
	7: "#9ca3af", // Outros
};
